import { CancelError } from './CancelError';

export default function isCancelError<E extends Error>(err: E) {
  return err instanceof CancelError;
}
